<app-hero
  [googleApiKey]="googleApiKey"
  [questionStart]="questionStart"
  (questionStartChange)="questionStart = $event"
/>
<div *ngIf="questionStart == false && getScreenWidth() <= 640 || getScreenWidth() > 640">
  <app-top-partners />
  <app-explore />
  <!-- <app-breakdown />
  <app-empower /> -->
</div>
